<template>
  <!-- {{ props.records }} -->
  <!-- <br> -->
  <!-- modalTheme {{ modalTheme }} -->
  <div class="create-task-form" :class="modalTheme">
    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" :class="modalTheme">
      <b-form-group id="selectRecipientsGroup" label="Select Recipients: (type names, groups to lookup)" label-for="selectRecipientsInput">
        <Multiselect
          v-model="form.recipients[0]"
          :multiple="false"
          :close-on-select="true"
          :hide-selected="true"
          :options="messageTypeUsers"
          placeholder="Select..."
          label="name"
          track-by="name"
        ></Multiselect>

        <pre hidden class="language-json"><code style="color:cyan;">{{ form.recipients }}</code></pre>
      </b-form-group>

      <b-form-group id="selectRecipientsCCGroup" label="Select CC Recipients: (type names, groups to lookup)" label-for="selectCCRecipientsInput">
        <Multiselect
          v-model="form.recipientsCC[0]"
          :multiple="false"
          :close-on-select="true"
          :hide-selected="true"
          :options="messageTypeUsers"
          placeholder="Select..."
          label="name"
          track-by="name"
        ></Multiselect>

        <pre hidden class="language-json"><code style="color:yellow;">{{ form.recipientsCC }}</code></pre>

        <!-- <dx-tag-box
				:items="messageTypeUsers"
				:search-enabled="true"
				applyValueMode="useButtons"
				id-expr="id"
				display-expr="name"
				:show-selection-controls="true"
				:on-value-changed="onMultipleRecipientsSelectionChanged"
				apply-value-mode="useButtons"
			/>-->
      </b-form-group>

      <b-form-group :class="modalTheme" id="selectTaskTypes" label="Select type" label-for="selectTaskType">
        <b-form-select :class="modalTheme" v-model="form.taskTypes" :options="taskTypeOptions"></b-form-select>

        <pre hidden class="language-json"><code style="color:yellow;">{{ form.taskTypes }}</code></pre>

        <!-- <dx-tag-box
				:items="messageTypeUsers"
				:search-enabled="true"
				applyValueMode="useButtons"
				id-expr="id"
				display-expr="name"
				:show-selection-controls="true"
				:on-value-changed="onMultipleRecipientsSelectionChanged"
				apply-value-mode="useButtons"
			/>-->
      </b-form-group>

      <b-form-group id="subjectInputGroup" label="Subject" label-for="subjectInput" :class="modalTheme">
        <b-form-input :class="modalTheme" id="subjectInput" type="text" v-model="form.subject" required placeholder></b-form-input>
      </b-form-group>
      <b-form-group id="bodyInputGroup" label="Instructions / Message" label-for="bodyInput">
        <b-form-textarea :class="modalTheme" required id="bodyInput" v-model="form.body" placeholder :rows="3" :max-rows="6"> </b-form-textarea>
      </b-form-group>

      <b-form-group>
        <h6 v-if="props.records?.length > 0" class="text-center">Selected Records</h6>
        <DxDataGrid v-if="props.records?.length > 0" class="selected-records-grid" :show-borders="true" :data-source="props.records" :row-alternation-enabled="true" :column-auto-width="true">
          <dx-column data-field="type" caption="Type" />
          <dx-column data-field="description" caption="Description" />
          <!-- <dx-column data-field="instruction" caption="Instructions" cell-template="instructions" /> -->

          <template #description="{ data: record }">
            <b-col cols="8">master view {{ record.description }} </b-col>

            <!-- <span class="dx-code-description">{{ record.description }}</span> -->
          </template>

          <!-- <template #myWorkDetail="{ data: record }">
						<div >
							<b-row style="background-color: #dcf1de">
								<b-col cols="8">master view {{ record }} </b-col>

							</b-row>

						</div>
					</template> -->

          <DxScrolling mode="virtual" row-rendering-mode="virtual" :use-native="true" />
          <!-- <div slot="instructions" slot-scope="{ data }">
                <textarea class="form-control form-control-sm" rows="2" placeholder="instructions" />
					</div>-->
        </DxDataGrid>
      </b-form-group>

      <!-- <b-form-group v-if="props.records.length > 0 && workListStore.selectedPatients.length > 0">
	22		records {{ records }}
				<DxDataGrid class="selected-records-grid" :show-borders="true" :data-source="props.records"
					:row-alternation-enabled="true" :column-auto-width="true">
					<dx-column data-field="firstName" caption="firstName" />>
					<dx-column data-field="lastName" caption="lastName" /> -->
      <!-- <dx-column data-field="instruction" caption="Instructions" cell-template="instructions" /> -->
      <!-- <div slot="description" slot-scope="{ data }">
						<span class="dx-code-description">{{ data.data.description }}</span>
					</div>-->

      <!-- <dx-scrolling mode="virtual" row-rendering-mode="virtual" :use-native="true" /> -->
      <!-- <div slot="instructions" slot-scope="{ data }">
                <textarea class="form-control form-control-sm" rows="2" placeholder="instructions" />
					</div>-->
      <!-- </DxDataGrid>
			</b-form-group> -->

      <b-row cols="2">
        <b-col>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input :class="modalTheme" v-model="form.allowDelegation" type="checkbox" class="custom-control-input" id="allowDelegationCheckbox" />
              <label for="allowDelegationCheckbox" class="custom-control-label">Allow Delegation</label>
            </div>
          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input v-model="form.includeContext" type="checkbox" class="custom-control-input" id="contextCheckbox" />
              <label for="contextCheckbox" class="custom-control-label">Include Patient Context</label>
              <pre hidden class="language-json"><code style="color:cyan;">{{ form.includeContext }}</code></pre>
              <pre class="language-json"><code style="color:yellow;">patientId: {{ form.patientId }}</code></pre>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input v-model="form.required" type="checkbox" class="custom-control-input" id="requiredCheckbox" />
              <label for="requiredCheckbox" class="custom-control-label">Set Priority</label>
            </div>
          </div></b-col
        >

        <b-col>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input v-model="form.isTask" type="checkbox" class="custom-control-input" id="taskActionCheckbox" />
              <label for="taskActionCheckbox" class="custom-control-label">Task (Action required)</label>
            </div>
          </div>

          <!-- <div class="form-group">
					<div class="custom-control custom-checkbox">
						<input v-model="form.patientOutreach" type="checkbox" disabled class="custom-control-input" id="patientOutreachCheckbox" />
						<label for="patientOutreachCheckbox" class="custom-control-label" style="color:#dcf1de">Patient Outreach</label>
					</div>
				</div> -->
        </b-col>
      </b-row>

      <!-- use v-show here -->
      <div :style="{ visibility: dateVisible ? 'visible' : 'hidden' }" :class="modalTheme">
        <b-form-group id="datePickerGroup" label="Due Date:" label-for="dueDateInput" :class="modalTheme">
          <!-- <datepicker id="dueDateInput" v-model="form.date" name="dueDateInput"></datepicker> -->
          <b-form-datepicker :class="modalTheme" id="dueDateInput" v-model="form.date" name="dueDateInput"></b-form-datepicker>
        </b-form-group>
        <b-form-group label="Priority Level">
          <b-form-radio-group id="priority-radio-group" v-model="form.priority" name="priority-radio-group">
            <b-form-radio :value="0">Low</b-form-radio>
            <b-form-radio :value="1">Medium</b-form-radio>
            <b-form-radio :value="2">High</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>

      <pre hidden class="language-json"><code style="color:cyan;">{{ form }}</code></pre>

      <div class="d-flex">
        <b-row class="ml-auto">
          <b-col cols="*">
            <b-button :class="modalTheme" type="reset" variant="primary-green">Clear Form</b-button>
          </b-col>
          <b-col>
            <b-button :class="modalTheme" class="mr-3" type="submit" variant="primary-green">Submit</b-button>
          </b-col>
        </b-row>
      </div>
    </b-form>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { toast } from "vue3-toastify";
import {
  DxDataGrid,
  DxColumn,
  DxButton,
  DxPager,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxHeaderFilter,
  DxLoadPanel,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxMasterDetail,
  DxSelection,
  DxScrolling,
} from "devextreme-vue/data-grid";

import Multiselect from "vue-multiselect";

// * STOREs
import { useStoreUser } from "@/stores/userStore";
const userStore = useStoreUser();
import { useStoreWorkList } from "@/stores/workListsStore";
const workListStore = useStoreWorkList();
// * STOREs
import { usePatientStore } from "@/stores/patientStore";
const patientStore = usePatientStore();
// * STOREs
import { useStoreTaskBuilder } from "@/stores/taskBuilderStore";
const taskbuilderStore = useStoreTaskBuilder();

// & PROPS
const props = defineProps({
  records: {
    type: Array,
    default: () => [],
  },
  context: {
    type: Object,
    default: () => [],
  },
});
// * a computed ref
const messageTypeUsers = computed(() => {
  // console.log(userStore.userLists)
  // console.log(userStore.users)
  return [...userStore.userLists, ...userStore.users];
});
// console.log('messageTypeUsers')
// console.log(messageTypeUsers)

const dateVisible = computed(() => {
  return form.value.required;
});

const modalTheme = computed(() => userStore.bModalTheme);

// & FORM
const form = ref({
  subject: "",
  body: "",
  includeContext: true,
  allowDelegation: true,
  date: null,
  recipients: [], // use this recipient for what actually gets posted. we need the two below because model binding is to an array for multiple and an object for single
  recipientsCC: [], //todo NEW
  taskTypes: 10, //[], //todo NEW
  required: true,
  priority: 0,
  patientId: patientStore.currentPatientId,
  SelectedRecords: taskbuilderStore.getAllTaskRecords,
  isTask: false,
  patientOutreach: false,
});
// console.log(" Base FORM");
// console.log(form.value);

function createForm() {
  return {
    subject: "",
    body: "",
    includeContext: true,
    allowDelegation: true,
    date: null,
    recipients: [], // use this recipient for what actually gets posted. we need the two below because model binding is to an array for multiple and an object for single
    recipientsCC: [], //todo NEW
    taskTypes: 10, //[], //todo NEW
    required: true,
    priority: 0,
    patientId: 0,
    SelectedRecords: [],
    isTask: false,
    patientOutreach: false,
  };
}

// * EMITTER
const emit = defineEmits(["createNewTask", "close-modal"]);

const AreIdsShown = ref(true);
// const subject = ref('');
// const body = ref('');
// const selectedTaskRecords = ref([]);
// const patientId = ref(0);
// const formA = ref( ...createForm());
// // console.log(' formA FORM')
// // console.log(formA.value)

const taskTypeOptions = ref([
  { value: 10, text: "Message" },
  { value: 20, text: "Coding" },
  // { value: 30, text: 'Patient' },
  { value: 40, text: "Pharmacy" },
  { value: 50, text: "Orders" },
  { value: 60, text: "General" },
  { value: 70, text: "Scheduling" },
  //	{ value: 80, text: 'Reminder' },
  // { value: 90, text: 'EMR Messages' },
]);

const taskTypeOptionsWithReminders = ref([
  { value: 10, text: "Message" },
  { value: 20, text: "Coding" },
  // { value: 30, text: 'Patient' },
  { value: 40, text: "Pharmacy" },
  { value: 50, text: "Orders" },
  { value: 60, text: "General" },
  { value: 70, text: "Scheduling" },
  { value: 80, text: "Reminder" },
  // { value: 90, text: 'EMR Messages' },
]);

function onSubmit(e) {
  // console.log("     Create New Task  >  onSubmit");
  // console.log(" CreateNewTask  > onSubmit");
  // console.log("E");
  // console.log(e);

  // console.log("props.");
  // console.log(props.records);
  // console.log(props.context);

  // console.log()
  // // console.log(form.value.recipients[0].id)

  if (form.value.recipients.length < 1) {
    toast.error("Please select recipient(s)");
    return;
  }

  const isEmptyOrSpaces = (str) => {
    return /^\s*$/.test(str) === true;
  };

  if (isEmptyOrSpaces(form.value.subject)) {
    toast.error("Please provide a subject");
    return;
  }
  if (isEmptyOrSpaces(form.value.body)) {
    toast.error("Please provide a message body");
    return;
  }

  // console.log(form.value.date)
  // console.log()
  // console.log(form.value.required)
  // console.log()
  if (!form.value.date && form.value.required) {
    toast.error("Please provide a valid due date");
    return;
  }

  // console.log(".................................................form.selectedTaskRecords");
  form.value.SelectedRecords = props.records;
  // console.log(form.value.SelectedRecords);

  // // console.dir(this.form.patientId)

  const payload = {
    ...form.value,
    recipients: form.value.recipients.map((recipient) => recipient.id),
    recipientsCC: form.value.recipientsCC.map((recipient) => recipient.id),
  };

  // console.log("     FORM  PAYLOAD");
  // console.log(payload);

  // ^ EMT Create NEW TASK : PAYLOAD
  // this.$emit('createNewTask', payload)
  emit("createNewTask", payload);

  onReset();
}

function onReset() {
  closeModal();
}
function closeModal() {
  // this.$emit('close-modal')
  emit("close-modal");
  form.value = { ...createForm() };
}

// Watch for changes in props to update the form (if needed)
watch(
  () => taskbuilderStore.getAllTaskRecords,
  (newVal) => {
    // console.log("            ******************                          Updating Selected Records in form.value");
    form.value.SelectedRecords = newVal;
  }
);

onMounted(() => {
  // console.clear();
  // console.log("onMounted() :      Create NEW TASK Form  >>>>");
  // console.log("props : ");
  // console.log(props);
  // console.log(" prop   records ");
  // console.log(props.records);
  // console.log("form : ");
  // console.log(form);
});
</script>

<!-- * MultiSelect CSS -->
<!-- <style src="../../node_modules/vue-multiselect/dist/vue-multiselect.css"></style> -->

<style src="vue-multiselect/dist/vue-multiselect.css"></style>

<style lang="scss" scoped>
.create-task-form {
  text-align: initial; // need this because the dx-toolbar text-align: center was causing problems with the labels
  background-color: transparent; // #6e796f;
  color: transparent;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 10px;
  border-radius: 5px;
}

.dx-code-description {
  display: inline-block;
  width: 100%;
  overflow-x: auto;
}

.selected-records-grid {
  max-height: 200px;
}

.btn-primary-green {
  border: none;
  text-decoration: none;
  color: #fcfefc;
  background-color: #b0c1b2;
}

.btn-primary-green:hover {
  background-color: #caeacd;
  color: #123486;
  border-radius: 0px 0px 0px 0px;
}

.btn-sm,
.btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
  border-radius: 0.2rem;
  background: #eef8ef;
}

.btn-primary-green:focus,
.btn-primary-green.focus {
  box-shadow: 1px 0px 0px 0px #b0c1b2 inset;
  color: #123486;
  background-color: #a5dbaa;
  font-weight: bolder;
}

.btn-primary-green:disabled,
.btn-primary-green.disabled {
  color: #eef8ef;
  background-color: #a62631;
  border-color: #d8d514;
}

.btn-sm,
:disabled,
.btn-sm,
.disabled {
  color: #eef8ef;
  background-color: #2646a6;
  border-color: #d8d514;
}
</style>
